module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "product productChoose"
  }, [_c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "flag"
  }, [(_vm.dataPackage.attributes.evaluated == 0) ? _c('p', {
    staticClass: "tag no-evaluado"
  }, [_vm._v("No evaluado")]) : _vm._e(), _vm._v(" "), (_vm.dataPackage.attributes.evaluated == 1) ? _c('p', {
    staticClass: "tag evaluado"
  }, [_vm._v("Evaluado")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "productCode bold"
  }, [_vm._v("#" + _vm._s(_vm.dataPackage.attributes.purchaseOrder.attributes.order_code + " - " + _vm.dataPackage.attributes.order_number))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.fromShipmentFlag && _vm.dataPackage.attributes.purchaseOrder.attributes.has_packages_with_reposition && _vm.dataPackage.attributes.has_reposition_generated && !_vm.dataPackage.attributes.order_reposition_evaluated) ? _c('span', [_vm._v("\n            Este paquete necesita de reposiciones, por lo que se debe autorizar su orden\n          ")]) : (_vm.fromShipmentFlag && _vm.dataPackage.attributes.purchaseOrder.attributes.has_packages_with_reposition && !_vm.dataPackage.attributes.has_reposition_generated && !_vm.dataPackage.attributes.order_reposition_evaluated) ? _c('span', [_vm._v("\n            Este paquete no necesita reposiciones, pero hay otros paquetes de la misma orden que sí lo necesitan\n          ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n          \n          Ejemplares originales: "), _c('span', {
    staticClass: "productCode"
  }, [_vm._v(_vm._s(_vm.dataPackage.attributes.items_from_order))]), _vm._v("\n          Ejemplares de reposición: "), _c('span', {
    staticClass: "productCode"
  }, [_vm._v(_vm._s(_vm.dataPackage.attributes.items_from_reposition))]), _vm._v("\n          Ejemplares totales: "), _c('span', {
    staticClass: "productCode"
  }, [_vm._v(_vm._s(_vm.dataPackage.attributes.number_of_items))])]), _vm._v(" "), (_vm.dataPackage.attributes.evaluated == 0) ? _c('div', {
    staticClass: "botones-evaluacion"
  }, [_c('div', [(_vm.dataPackage.attributes.evaluated == 0) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.evaluatePackage
    }
  }, [_vm._v("Evaluar")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.dataPackage.attributes.evaluated == 1) ? _c('div', {
    staticClass: "botones-evaluacion"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'show-package',
        params: {
          id: _vm.dataPackage.id
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Ver detalle")])])], 1) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalStatePackages",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalStatePackages"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Ingresar datos de evaluación del paquete")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModalStatePackages
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('span', {
    staticClass: "modal-subtitle"
  }, [_vm._v("Evaluación del paquete #" + _vm._s(_vm.dataPackage.attributes.purchaseOrder.attributes.order_code + " - " + _vm.dataPackage.attributes.order_number))]), _vm._v(" "), _c('div', {
    staticClass: "eval-content"
  }, [_c('span', {
    staticClass: "eval-content-1"
  }, [_vm._v("N° de ejemplares exitosos ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.state1),
      expression: "state1"
    }],
    staticClass: "form-control eval-content-2",
    attrs: {
      "type": "number",
      "name": "state_1"
    },
    domProps: {
      "value": (_vm.state1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state_1')),
      expression: "errors.has('state_1')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state_1')))]), _vm._v(" "), (_vm.deltaItems != null && parseInt(_vm.deltaItems) != 0) ? _c('span', [_vm._v(_vm._s(parseInt(_vm.deltaItems) > 0 ? "Hay un déficit de " + parseInt(_vm.deltaItems) + " items" : "Hay un exceso de " + parseInt(_vm.deltaItems) * (-1) + " items"))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "eval-content"
  }, [_c('span', {
    staticClass: "eval-content-1"
  }, [_vm._v("N° de ejemplares del producto correcto con desperfectos ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.state2),
      expression: "state2"
    }],
    staticClass: "form-control eval-content-2",
    attrs: {
      "type": "number",
      "name": "state_2"
    },
    domProps: {
      "value": (_vm.state2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state_2')),
      expression: "errors.has('state_2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state_2')))]), _vm._v(" "), _c('div', {
    staticClass: "eval-content"
  }, [_c('span', {
    staticClass: "eval-content-1"
  }, [_vm._v("N° de ejemplares de otro producto sin desperfectos ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.state3),
      expression: "state3"
    }],
    staticClass: "form-control eval-content-2",
    attrs: {
      "type": "number",
      "name": "state_3"
    },
    domProps: {
      "value": (_vm.state3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state_3')),
      expression: "errors.has('state_3')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state_3')))]), _vm._v(" "), _c('div', {
    staticClass: "eval-content"
  }, [_c('span', {
    staticClass: "eval-content-1"
  }, [_vm._v("N° de ejemplares de otro producto con desperfectos  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.state4),
      expression: "state4"
    }],
    staticClass: "form-control eval-content-2",
    attrs: {
      "type": "number",
      "name": "state_4"
    },
    domProps: {
      "value": (_vm.state4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state_4')),
      expression: "errors.has('state_4')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state_4')))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.askToSendEvaluation
    }
  }, [_vm._v("Evaluar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalIncidentsPackages",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "modalIncidentsPackages"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Evaluación del paquete # " + _vm._s(_vm.dataPackage.id) + " - " + _vm._s(_vm.dataPackage.attributes.order_number))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModalIncidentsPackages
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [(_vm.listIncidents.length > 0) ? _c('div', [_c('div', {}, [_c('h5', [_vm._v("Incidencias generadas")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.listIncidents), function(incident) {
    return _c('div', {}, [_c('span', [_vm._v("Descripcion:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(incident.attributes.description))]), _vm._v(" "), (incident.attributes.clusterable_type == 'different_quantity') ? _c('div', {}, [_c('div', {}, [_c('span', [_vm._v("Ejemplares correctos sobre totales en el paquete: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(incident.attributes.clusterable.attributes.correct_items + "/" + incident.attributes.clusterable.attributes.total_items))]), _vm._v(" "), _c('span', [_vm._v("Tipo: ")]), _vm._v(" "), (incident.attributes.clusterable.attributes.delta_type == 1) ? _c('span', [_vm._v(" Déficit")]) : (incident.attributes.clusterable.attributes.delta_type == 2) ? _c('span', [_vm._v("Exceso")]) : _c('span', [_vm._v(" No definido")])])]) : _vm._e(), _vm._v(" "), (incident.attributes.clusterable_type == 'waste') ? _c('div', {}, [_c('div', {}, [(incident.attributes.clusterable.attributes.correct_product_flag == 1) ? _c('span', [_vm._v("Items mermados:")]) : _c('span', [_vm._v("Ejemplares mermados de otros productos:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(incident.attributes.clusterable.attributes.wasted_items))])])]) : _vm._e(), _vm._v(" "), (incident.attributes.clusterable_type == 'wrong') ? _c('div', {}, [_c('div', {}, [(incident.attributes.clusterable.attributes.wasted_flag == 0) ? _c('span', [_vm._v("Ejemplares de otros productos no mermados:")]) : _c('span', [_vm._v("Ejemplares de otros productos mermados:")]), _vm._v(" "), _c('span', [_vm._v("\n                     " + _vm._s(incident.attributes.clusterable.attributes.wrong_items) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('hr')])
  })], 2) : (_vm.listIncidents.length == 0) ? _c('div', [_c('div', {
    staticClass: "center"
  }, [_c('span', [_vm._v("No se generaron incidencias")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.hideModalIncidentsPackages()
      }
    }
  }, [_vm._v("Cerrar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("¿Estás seguro que deseas completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendEvaluationData()
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmation()
      }
    }
  }, [_vm._v("Cancelar")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e191ba7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/items/card-evaluate-orders.vue
// module id = 1870
// module chunks = 1